"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoverSection = void 0;
const react_1 = __importStar(require("react"));
const shared_random_g_thumbnail_1 = require("@guidde-co/shared.random-g-thumbnail");
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const Popover_1 = __importDefault(require("@material-ui/core/Popover"));
const getTimeSuffix = (time) => {
    let formattedTime = 0;
    let suffix = '';
    /** Seconds */
    if (time < 60) {
        formattedTime = time;
        suffix = 's';
        /** Minutes */
    }
    else if (time < 3600) {
        formattedTime = time / 60;
        suffix = 'm';
        /** Hours */
    }
    else {
        formattedTime = time / 60 / 60;
        suffix = 'h';
    }
    return `${Math.round(formattedTime)}${suffix}`;
};
const useStyles = (0, makeStyles_1.default)(theme => ({
    container: {
        [theme.breakpoints.down('md')]: {
            width: '120px'
        },
        [theme.breakpoints.between('md', 'xl')]: {
            width: '200px'
        },
        [theme.breakpoints.up('xl')]: {
            width: '240px'
        },
        maxHeight: '230px',
        backgroundColor: 'white',
        borderRadius: '5px',
        border: '1px solid gainsboro',
        zIndex: 25,
        position: 'absolute',
        bottom: '50px',
        overflow: 'hidden',
        '&:after': {
            position: 'absolute',
            backgroundColor: 'yellow',
            content: '',
            width: 0,
            height: 0,
            borderLeft: '5px solid red',
            borderRight: '5px solid red',
            borderTop: '7px solid rgba(0,0,0, .7)'
        }
    },
    screenShotImg: {
        width: '100%',
        height: 'auto',
        objectFit: 'cover'
    },
    chapterName: {
        maxWidth: '250px',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical',
        textOverflow: 'ellipsis',
        display: 'block',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        wordBreak: 'break-word',
        marginLeft: '4px',
        fontWeight: 'bold'
    },
    applications: {
        display: 'flex',
        gap: 4,
        alignItems: 'center',
        width: '12vw',
        marginTop: '2px'
    },
    logo: {
        height: '15px',
        width: 'auto'
    },
    chipRoot: {
        padding: '4px',
        margin: '4px 4px 0 0',
        fontWeight: 500,
        fontSize: '12px',
        background: '#eeeeee'
    },
    moreApps: {
        position: 'relative'
    },
    tooltipContent: {
        display: 'flex',
        alignItems: 'center',
        gap: 2
    }
}));
exports.HoverSection = (0, react_1.memo)(({ section, index, totalSections }) => {
    const classes = useStyles();
    const { thumbnail, start, end, duration, title, applications } = section;
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const open = Boolean(anchorEl);
    const showMoreApplications = applications && (applications === null || applications === void 0 ? void 0 : applications.length) > 2;
    const applicationsToShow = showMoreApplications
        ? applications.slice(0, 2)
        : applications;
    const hiddenApplications = showMoreApplications
        ? applications.length - 2
        : 0;
    return (react_1.default.createElement(Box_1.default, { className: classes.container },
        react_1.default.createElement("img", { className: classes.screenShotImg, src: thumbnail || (0, shared_random_g_thumbnail_1.generateDefaultThumb)(), alt: `${title} screenshot` }),
        react_1.default.createElement(Box_1.default, { p: 1, mt: 1 },
            react_1.default.createElement(Box_1.default, { display: "flex", alignItems: "center", mb: 0.5 },
                react_1.default.createElement(Typography_1.default, { variant: "body2" },
                    react_1.default.createElement("b", null, `${index}/${totalSections}`)),
                react_1.default.createElement(Typography_1.default, { variant: "body2", className: classes.chapterName }, title)),
            react_1.default.createElement(Typography_1.default, { variant: "body2" }, getTimeSuffix(duration
                ? duration
                : end !== undefined && start !== undefined
                    ? end - start
                    : 0)),
            !!(applications === null || applications === void 0 ? void 0 : applications.length) && (react_1.default.createElement(Box_1.default, { className: classes.applications }, applicationsToShow === null || applicationsToShow === void 0 ? void 0 :
                applicationsToShow.map(application => (react_1.default.createElement("img", { src: application.applicationLogo, width: "25px", key: application.applicationId }))),
                !!hiddenApplications && (react_1.default.createElement("div", { className: classes.moreApps },
                    react_1.default.createElement(Typography_1.default, { variant: "body2", onMouseEnter: (event) => {
                            setAnchorEl(event.currentTarget);
                        }, onMouseLeave: () => setAnchorEl(null) },
                        "+",
                        hiddenApplications,
                        " more ",
                        open),
                    react_1.default.createElement(Popover_1.default, { id: "mouse-over-popover", open: open, anchorEl: anchorEl, anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'center'
                        }, style: {
                            pointerEvents: 'none'
                        }, transformOrigin: {
                            vertical: 'top',
                            horizontal: 'center'
                        }, onClose: () => {
                            setAnchorEl(null);
                        }, disableRestoreFocus: true },
                        react_1.default.createElement(Box_1.default, { className: classes.tooltipContent }, applications === null || applications === void 0 ? void 0 : applications.slice(-hiddenApplications).map(app => (react_1.default.createElement("img", { src: app.applicationLogo, width: "25px", key: app.applicationId, alt: app.applicationName }))))))))))));
});
//# sourceMappingURL=hover-section.js.map